import * as React from "react";

function SvgParagraph(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M4.5 3h3.1c2.2 0 3.9.8 3.9 3.1 0 2.2-1.6 3.2-3.8 3.2H6.3V13H4.5V3zm3.1 4.9c1.5 0 2.2-.6 2.2-1.8 0-1.3-.8-1.7-2.3-1.7H6.3v3.5h1.3z" /></svg>;
}

export default SvgParagraph;